import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=6116f34a&scoped=true"
import script from "./VideoPlayer.vue?vue&type=script&lang=ts"
export * from "./VideoPlayer.vue?vue&type=script&lang=ts"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=6116f34a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6116f34a",
  null
  
)

export default component.exports